<template>
  <section id="main-content" style="margin-top: 60px">
    <nav class="mt-5 ms-4 text-center text-md-start">
      <h2 :class="'tabswitch' + (this.allReports ? ' ' : ' active')" @click="switchView">
        {{ language.includes('en') ? "Report Categories" : "Catégories de rapport" }}
      </h2>
      <h2 :class="'tabswitch' + (this.allReports ? ' active' : '')" @click="switchView">
        {{ language.includes('en') ? "All Reports" : "Tous les rapports" }}
      </h2>
    </nav>

    <div class="container-fluid" id="currentRow" v-if="!allReports">
      <h2 class="fw-bold text-muted">
        {{ language.includes('en') ? "Current Reports" : "Rapports actuels" }}
      </h2>

      <!-- SP: Current LMI -->
      <carousel-row :reports="currentReports.LMI"
        :category="language.includes('en') ? 'Labour Market Information' : 'Information sur le marché du travail'"
        abbr="lmi" status="Current" />
      <!-- SP: Current NOS -->
      <carousel-row :reports="currentReports.NOS"
        :category="language.includes('en') ? 'National Occupational Standards' : 'Normes Professionelles Nationales'"
        abbr="nos" status="Current" />
    </div>
    <div class="container-fluid" id="archiveRow" v-show="!allReports">
      <h2 class="fw-bold text-muted">
        {{ language.includes('en') ? "Reports from our Archive" : "Rapports de nos archives" }}
      </h2>

      <!-- SP: Archive LMI -->
      <carousel-row :reports="archiveReports.LMI"
        v-show="archiveReports.LMI.filter((element => { return element.language == this.language })).length > 0"
        :category="language.includes('en') ? 'Labour Market Information' : 'Information sur le marché du travail'"
        abbr="archive-lmi" status="Archive" />
      <carousel-row :reports="archiveReports.NOS"
        v-show="archiveReports.NOS.filter((element => { return element.language == this.language })).length > 0"
        :category="language.includes('en') ? 'National Occupational Standards' : 'Normes Professionelles Nationales'"
        abbr="archive-nos" status="Archive" />
      <carousel-row :reports="archiveReports.HR"
        v-show="archiveReports.HR.filter((element => { return element.language == this.language })).length > 0"
        :category="language.includes('en') ? 'Human Resources' : 'Ressources humaines'" abbr="archive-hr"
        status="Archive" />
    </div>

    <!-- SP: All reports grid -->
    <div class="container-fluid" id="allReportsRow" v-if="allReports">
      <grid-container :allReports="reports" category="All Reports"
        :gridTitle="language.includes('en') ? 'Browse All Reports' : 'Parcourir tous les rapports'" abbr="all"
        status="All Reports" :language="language" />
    </div>
  </section>
</template>

<script>
// import "bootstrap";

import '../assets/_globals.scss';
import '../assets/style.scss';
import CarouselRow from './CarouselRow';
import GridContainer from './GridContainer.vue'
export default {
  name: "IndexPage",
  components: { CarouselRow, GridContainer },
  data() {
    return {
      reports: [],
      archiveReports: { LMI: [], NOS: [], HR: [] },
      currentReports: { LMI: [], NOS: [] },
      loading: false,
      allReports: false,
    };
  },
  methods: {
    switchView() {
      this.allReports = !this.allReports;
    },
    getCookie(name) {
      var dc, prefix, begin, end;

      dc = document.cookie;
      prefix = name + "=";
      begin = dc.indexOf("; " + prefix);
      end = dc.length; // default to end of the string

      if (begin !== -1) {
        begin += 2;
      } else {
        begin = dc.indexOf(prefix);
        if (begin === -1 || begin !== 0) return null;
      }

      if (dc.indexOf(";", begin) !== -1) {
        end = dc.indexOf(";", begin);
      }

      return decodeURI(dc.substring(begin + prefix.length, end)).replace(
        /\"/g,
        ""
      );
    },
  },
  computed: {
    language() {
      return this.getCookie("pll_language") ? this.getCookie("pll_language") : "en";
    },
  },
  mounted() {

    let vm = this;
    vm.loading = true;
    fetch(
      "https://eco.ca/wp-content/themes/hello-theme-child-master/reports_api.php"
    )
      .then((response) => response.json())
      .then((data) => {
        vm.reports = Object.values(data);

        vm.reports.reverse();

        for (var report in vm.reports) {
          if (vm.reports[report].post_category.includes("Archive")) {
            if (vm.reports[report].post_category.includes("LMI")) {
              vm.archiveReports.LMI.push(vm.reports[report]);
            } else if (vm.reports[report].post_category.includes("NOS")) {
              vm.archiveReports.NOS.push(vm.reports[report]);
            } else {
              vm.archiveReports.HR.push(vm.reports[report]);
            }
          } else {
            if (vm.reports[report].post_category.includes("Current")) {
              if (vm.reports[report].post_category.includes("LMI")) {
                vm.currentReports.LMI.push(vm.reports[report]);
              } else {
                vm.currentReports.NOS.push(vm.reports[report]);
              }
            }
          }
        }
        console.log(
          "fetched: ",
          data,
          vm.reports,
          vm.archiveReports,
          vm.currentReports
        );
        vm.loading = false;
      })
      .catch((err) => {
        console.error(err);
        vm.loading = false;
      });
  },
};
</script>
